import styled from 'styled-components';

const TituloWrapper = styled.div`
    font-size: ${props =>  props.type === "small" ? "20px;" : "27px;"}
    font-weight: 600;
    margin: 5px;
    padding: 10px;
`;

export default TituloWrapper
